import './HeaderSettingsContainer.css';

export function HeaderSettingsContainer({ children }: React.PropsWithChildren) {
    return <div className='header-settings'>{children}</div>;
}
